import request from '@/utils/request'

export function reportOnlineStatus(status) {
    return request({
        url: '/api/student/online-status/report',
        method: 'get',
        params: { status }
    })
}